<!--<p-organizationChart *ngIf="customerCredit.length > 0" [value]="customerCredit" selectionMode="single" [collapsible]="true" [style]="{'width':'100%'}" >-->
<!--    <ng-template let-node pTemplate="default">-->
<!--        <div class="p-2">-->
<!--           in templete {{ node?.type }}-&#45;&#45;{{node?.data?.customerDtoName}}-&#45;&#45;{{node?.data?.creditAmount}}-->
<!--            Hello My name is moiz-->
<!--        </div>-->
<!--    </ng-template>-->
<!--    out templete {{ customerCredit[0].type }}-&#45;&#45;{{customerCredit[0].data.customerDtoName}}-&#45;&#45;{{customerCredit[0].data.creditAmount}}-->
<!--</p-organizationChart>-->

<!--outer templete {{ customerCredit[0].type }}-&#45;&#45;{{customerCredit[0].data.customerDtoName}}-&#45;&#45;{{customerCredit[0].data.creditAmount}}-->
<!--&#45;&#45;&#45;&#45;-->
<!--{{customerCredit | json}}-->

<h5 class="">Payment Received Trace</h5>
@if (customerCredit) {
    <p-organizationChart [value]="customerCredit" [collapsible]="true" selectionMode="single" [style]="{'width':'100%'}">
<!--        <ng-template let-node pTemplate="CustomerCredit">-->
<!--            <div class="flex flex-column ">-->
<!--                <div class="flex align-items-center mb-2">-->
<!--                    <i [class]="node.icon + ' w-2rem h-2rem mr-2 border-1 border-300 p-1 border-round-lg text-primary bg-primary-50'" ></i>-->
<!--                    <span class="font-bold text-xl">CustomerCredit</span>-->
<!--                </div>-->

<!--                <div class="flex flex-column gap-1 text-700 align-items-start">-->
<!--                    <div><span class="font-medium text-900">Amount:</span> {{node.data.currency + node.data.creditAmount}}</div>-->
<!--                    <div><span class="font-medium text-900">Status:</span> {{CUSTOMERCREDITSTATUS.AVAILABLE}}</div>-->
<!--                    <div><span class="font-medium text-900">Source:</span> {{CUSTOMERCREDITSOURCE.OVERPAYMENT}}</div>-->
<!--                    <div><span class="font-medium text-900">Date:</span> {{node.data.date}}</div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </ng-template>-->
        <ng-template let-node pTemplate="default">
            <div class="flex flex-column ">
                <div class="flex align-items-center mb-2">
                    <i [class]="node.icon + ' w-2rem h-2rem mr-2 border-1 border-300 p-1 border-round-lg text-primary bg-primary-50'" ></i>
                    <span class="font-bold text-xl">{{node.label}}</span>
                </div>

                <div class="flex flex-column gap-1 text-700 align-items-start">
                    <div><span class="font-medium text-900">Amount:</span> {{node.data.currency + node.data.creditAmount}}</div>
                    <div><span class="font-medium text-900">Date:</span> {{node.data.date}}</div>
                </div>
            </div>
        </ng-template>
    </p-organizationChart>
}
